export const articles: Record<string, {
  id: string;
  title: string;
  category: string;
  date: string;
  views: number;
  image: string;
  author: string;
  content: string;
  tags: string[];
}> = {
  n1: {
    id: 'n1',
    title: '皇马逆转巴萨，姆巴佩梅开二度助球队登顶西甲榜首',
    category: '足球',
    date: '2026-08-09',
    views: 156000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20match%20action%20scene%20with%20players%20celebrating%20goal%20on%20stadium%20pitch%2C%20dramatic%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20movement%2C%20white%20and%20green%20kit%2C%20clean%20background%20with%20blurred%20crowd&width=1200&height=675&seq=article-n1&orientation=landscape',
    tags: ['西甲', '皇马', '巴萨', '姆巴佩', '国家德比'],
    content: `<p>在备受瞩目的西班牙国家德比中，皇家马德里凭借姆巴佩的精彩表现，以3比2逆转战胜巴塞罗那，成功登顶西甲积分榜。这场比赛在伯纳乌球场进行，现场座无虚席，超过8万名球迷见证了这一经典之战。</p>
<h2>比赛回顾</h2>
<p>比赛开场仅12分钟，巴塞罗那就由莱万多夫斯基率先破门。波兰前锋在禁区内接到佩德里的妙传后，冷静推射远角得手，巴萨1-0领先。</p>
<p>第35分钟，巴萨再度扩大领先优势。拉菲尼亚在右路突破后传中，费兰·托雷斯头球攻门，皮球应声入网，比分变成2-0。</p>
<p>下半场，皇马展开了疯狂的反扑。第52分钟，姆巴佩在禁区前沿接到贝林厄姆的传球后，晃开防守球员一脚劲射，皮球直挂球门死角，皇马扳回一城。</p>
<p>第68分钟，维尼修斯在左路突破后横传，姆巴佩门前抢点推射破门，将比分扳成2-2平。</p>
<p>第85分钟，皇马完成逆转。莫德里奇开出角球，吕迪格头球摆渡，姆巴佩门前凌空抽射，完成帽子戏法。最终皇马以3-2战胜巴萨。</p>
<h2>赛后声音</h2>
<p>皇马主教练安切洛蒂在赛后表示："这是一场难以置信的比赛，球员们展现出了顽强的斗志。姆巴佩的表现堪称完美，他是当今世界足坛最出色的球员之一。"</p>
<p>姆巴佩本人则谦虚地表示："这是全队的胜利，没有队友们的支持，我不可能打进三个球。国家德比永远是最特别的比赛，很高兴我们能够取胜。"</p>
<h2>数据统计</h2>
<p>全场比赛，皇马控球率为52%，射门18次，其中9次射正。巴萨控球率48%，射门12次，5次射正。姆巴佩一人贡献了3个进球，赛后获评全场最佳球员。</p>
<p>凭借这场胜利，皇马以3分优势领跑西甲积分榜，巴萨则滑落至第三位。</p>`,
  },
  n2: {
    id: 'n2',
    title: 'NBA夏季联赛：湖人新秀表现出色，率队取得三连胜',
    category: '篮球',
    date: '2026-08-08',
    views: 123000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20scene%20with%20player%20dunking%20on%20court%2C%20dramatic%20arena%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20movement%2C%20purple%20and%20gold%20uniform&width=1200&height=675&seq=article-n2&orientation=landscape',
    tags: ['NBA', '湖人', '夏季联赛', '新秀'],
    content: `<p>洛杉矶湖人在NBA夏季联赛中表现抢眼，新秀前锋在对阵勇士的比赛中砍下28分12篮板，帮助球队取得三连胜。这位被湖人队在首轮第5顺位选中的新秀，正在用自己的表现证明球队的选择是正确的。</p>
<h2>新秀闪耀</h2>
<p>这位年仅19岁的前锋在夏季联赛中场均贡献24.3分、10.7个篮板和4.2次助攻，投篮命中率高达52.8%。他的全面表现让人想起了湖人传奇球星科比·布莱恩特早期的风采。</p>
<p>"他有着不可思议的天赋和职业态度，"湖人夏季联赛主教练称赞道，"每天他都是第一个到达训练馆、最后一个离开的球员。这样的职业精神将帮助他在NBA取得成功。"</p>
<h2>团队配合</h2>
<p>除了新秀的个人表现外，湖人队的整体配合也令人印象深刻。球队在夏季联赛中场均助攻28.3次，展示出了良好的团队篮球理念。二年级后卫也在比赛中展现出了明显的进步，场均18.5分和7.8次助攻的数据相当亮眼。</p>
<p>"我们正在建立一种赢球文化，"湖人总经理表示，"夏季联赛只是一个开始，我们对新赛季充满期待。"</p>`,
  },
  n3: {
    id: 'n3',
    title: '温网决赛：德约科维奇力克阿尔卡拉斯，斩获第25座大满贯',
    category: '网球',
    date: '2026-08-07',
    views: 189000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20scene%20with%20player%20serving%20on%20grass%20court%2C%20Wimbledon%20style%2C%20white%20outfit%2C%20dramatic%20lighting%2C%20sports%20photography%2C%20clean%20green%20background&width=1200&height=675&seq=article-n3&orientation=landscape',
    tags: ['温网', '德约科维奇', '阿尔卡拉斯', '大满贯'],
    content: `<p>在温布尔登网球锦标赛男单决赛中，塞尔维亚名将德约科维奇经过五盘大战，最终击败西班牙新星阿尔卡拉斯，职业生涯第25次捧起大满贯奖杯。这场史诗级的对决持续了4小时32分钟，是温网历史上最精彩的决赛之一。</p>
<h2>比赛回顾</h2>
<p>第一盘，阿尔卡拉斯凭借着强大的发球和底线进攻以7-5先下一城。但德约科维奇迅速调整状态，以6-3扳回一盘。</p>
<p>第三盘，双方战至抢七，德约科维奇凭借丰富的经验以7-6(5)拿下。第四盘中阿尔卡拉斯展现出了惊人的韧性，以6-4将比赛拖入决胜盘。</p>
<p>决胜盘中，德约科维奇在关键时刻展现出了王者风范，以6-2锁定胜局，最终以3-2的总比分获胜。</p>
<h2>历史性时刻</h2>
<p>这第25座大满贯奖杯让德约科维奇超越了玛格丽特·考特的24座纪录，成为网球历史上获得大满贯单打冠军最多的球员。</p>
<p>"每一座大满贯奖杯都意义非凡，"德约科维奇在赛后表示，"能够在温布尔登实现这一里程碑，我感到无比荣幸。阿尔卡拉斯是一位了不起的对手，他将拥有极其辉煌的职业生涯。"</p>`,
  },
  n4: {
    id: 'n4',
    title: 'LCK夏季赛：T1战队3-1击败GEN，成功晋级季后赛决赛',
    category: '电竞',
    date: '2026-08-06',
    views: 98000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20players%20competing%20on%20stage%2C%20dramatic%20lighting%20with%20LED%20screens%2C%20large%20crowd%2C%20gaming%20tournament%20atmosphere%2C%20dynamic%20and%20colorful&width=1200&height=675&seq=article-n4&orientation=landscape',
    tags: ['LCK', 'T1', 'Faker', 'GEN', '英雄联盟'],
    content: `<p>在LCK夏季赛季后赛中，T1战队展现了强大的竞技状态，以3比1的总比分击败卫冕冠军GEN，率先锁定决赛席位。Faker带领的这支T1战队正在向队史第11座LCK冠军奖杯发起冲击。</p>
<h2>比赛详情</h2>
<p>第一局比赛，T1选择了一套前期强势的阵容，在15分钟时就建立了3000的经济领先。GEN虽然在中期尝试反扑，但T1的团战执行力更胜一筹，最终在32分钟推掉GEN的主水晶。</p>
<p>第二局GEN做出调整，选择了后期阵容。比赛一度进入GEN的节奏，但在关键的大龙团战中，Faker的阿狸精准魅惑到GEN双C，T1打出0换4的完美团战，一波结束比赛。</p>
<p>第三局GEN背水一战，Chovy的永恩发挥出色，帮助队伍扳回一局。但第四局T1没有再给对手机会，Gumayusi的金克斯在前期拿到双杀后一路滚雪球，最终T1以3-1拿下胜利。</p>
<h2>赛后展望</h2>
<p>"我们为这场比赛准备了很久，"Faker在赛后采访中说道，"GEN是一支非常强大的队伍，但今天我们打出了自己的风格。决赛我们会继续全力以赴。"</p>
<p>T1将在决赛中对阵DK与KT之间的胜者，决赛将于8月20日在首尔蚕室体育馆举行。</p>`,
  },
  ca1: {
    id: 'ca1',
    title: '英超新赛季前瞻：六大豪门争冠格局深度分析',
    category: '足球',
    date: '2026-08-09',
    views: 186000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Premier%20League%20stadium%20panoramic%20view%20with%20green%20pitch%20and%20packed%20stands%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20atmospheric%20haze%2C%20clean%20composition&width=1200&height=675&seq=article-ca1&orientation=landscape',
    tags: ['英超', '曼城', '利物浦', '阿森纳', '新赛季'],
    content: `<p>2026-2027赛季英超即将拉开帷幕，曼城、利物浦、阿森纳等六大豪门蓄势待发，新赛季争冠格局将如何演变？本文将从阵容变化、战术调整和赛季前景三个维度，为您深度解析新赛季英超争冠大势。</p>
<h2>曼城：卫冕冠军的挑战</h2>
<p>作为上赛季的冠军，曼城在新赛季面临着不小的挑战。德布劳内的离开给球队中场带来了巨大影响，但瓜迪奥拉的战术体系已经足够成熟。哈兰德的持续输出和福登的成长将是曼城卫冕的关键。</p>
<h2>利物浦：王者归来</h2>
<p>利物浦在转会市场上动作频频，签下了多名实力派球员。萨拉赫虽然年过三十，但状态依然出色。新帅的战术理念正在逐步融入球队，利物浦有望在新赛季重返争冠行列。</p>
<h2>阿森纳：青年军的崛起</h2>
<p>阿森纳上赛季表现惊艳，年轻球员的成长为球队注入了无限活力。萨卡和厄德高组成的中前场是英超最具威胁的进攻组合之一。如果能在关键比赛中保持稳定，阿森纳将是冠军的有力竞争者。</p>
<h2>其他竞争者</h2>
<p>切尔西、曼联和热刺也在积极补强阵容。切尔西在新帅的带领下展现出全新的面貌，曼联则依靠拉什福德和B费的稳定发挥保持竞争力。新赛季的英超争冠格局将前所未有的激烈。</p>`,
  },
  ca2: {
    id: 'ca2',
    title: 'NBA交易市场动态：湖人队重磅引援分析',
    category: '篮球',
    date: '2026-08-08',
    views: 142000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20arena%20interior%20with%20dramatic%20spotlight%20on%20court%2C%20professional%20sports%20photography%2C%20purple%20and%20gold%20color%20scheme%2C%20empty%20court%20preparation&width=1200&height=675&seq=article-ca2&orientation=landscape',
    tags: ['NBA', '湖人', '交易', '引援'],
    content: `<p>随着NBA休赛期的深入，各支球队纷纷进行阵容调整。湖人队最新引援引发广泛关注，新赛季前景值得期待。总经理佩林卡在休赛期的操作令人印象深刻。</p>
<h2>关键引援</h2>
<p>湖人队在自由市场上签下了一名全明星级别的控球后卫，这将极大缓解詹姆斯在组织端的压力。同时，球队还补强了内线深度，引进了一位场均两双的实力派中锋。</p>
<p>"我们的目标始终是总冠军，"佩林卡在新闻发布会上表示，"这些引援将帮助我们在新赛季更具竞争力。"</p>
<h2>阵容展望</h2>
<p>新赛季湖人队的首发阵容预计将由新援控卫、里夫斯、詹姆斯、戴维斯和新援中锋组成。这套阵容在攻防两端都具备出色的实力，是西部冠军的有力竞争者。</p>`,
  },
  ca3: {
    id: 'ca3',
    title: 'LCK夏季赛决赛前瞻：T1能否卫冕？',
    category: '电竞',
    date: '2026-08-07',
    views: 165000,
    author: '米乐体育编辑部',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20and%20packed%20crowd%2C%20dramatic%20stage%20lighting%2C%20professional%20gaming%20tournament%20atmosphere%2C%20red%20and%20white%20color%20theme&width=1200&height=675&seq=article-ca3&orientation=landscape',
    tags: ['LCK', 'T1', '决赛', 'Faker'],
    content: `<p>LCK夏季赛进入白热化阶段，T1战队以常规赛第一的身份晋级季后赛，Faker领衔的阵容能否再次证明自己？本文为您带来LCK夏季赛决赛的全面前瞻。</p>
<h2>T1的状态</h2>
<p>T1在常规赛中展现出了统治级的表现，以16胜2负的战绩高居榜首。Faker在常规赛中的表现依然稳定，场均KDA高达5.8。上单Zeus的成长令人惊喜，已经成为LCK最具威胁的上单选手之一。</p>
<h2>对手分析</h2>
<p>无论决赛对手是DK还是KT，T1都拥有心理优势。在对阵DK的常规赛交手中，T1取得了2胜0负的战绩。而面对KT，T1同样保持全胜。</p>
<p>"我们尊重每一个对手，"T1主教练表示，"但我们的目标是冠军，我们会为此全力以赴。"</p>
<h2>决赛看点</h2>
<p>如果T1能够在决赛中取胜，这将是Faker职业生涯的第11座LCK冠军奖杯，也将追平LCK历史上最多冠军的记录。同时，T1也将以LCK一号种子的身份出征今年的全球总决赛。</p>`,
  },
};

export const relatedArticles = [
  'n2', 'n3', 'n4',
];